// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Mj-z","carouselContainer":"Nj-z","carouselContent":"Oj-z"};